import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/images/home/kong.png';
const _withScopeId = n => (_pushScopeId("data-v-214c1b10"), n = n(), _popScopeId(), n);
const _hoisted_1 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1));
const _hoisted_2 = {
  key: 0,
  class: "empty-text"
};
export default {
  __name: 'moduleEmpty',
  props: {
    text: {
      type: String,
      default: 'No items at this time'
    },
    size: {
      type: String,
      default: ''
    }
  },
  setup(__props) {
    const props = __props;
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", {
        class: _normalizeClass(["empty-content", __props.size])
      }, [_hoisted_1, props.text ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(props.text), 1)) : _createCommentVNode("", true), _renderSlot(_ctx.$slots, "default")], 2);
    };
  }
};